export const biddersMap = {
  myTarget: '821949',
  buzzoola: '3214512',
  roxot: '2744087',
  mediasniper: '3213462',
  adriver: '1644441',
  hybrid: '3216490',
  betweendigital: '1638365',
}

/**
 * Так как конфиги переиспользуются, то иногда нужна их до настройка
 * В данном случае отличаются лишь betweendigital
 */
export const biddersPlacement = {
  betweendigital: '4126668',
  PhotoViewBetweendigital: '4106650',
}

export const BannerOwnerId = 258560

/**
 * Баннеры с HB
 */
export const BannerId = {
  topProfileBanner: 'top-profile-banner',
  feedProfileBanner: 'feed-profile-banner',
  searchListBanner: 'search-list-banner',
  hitAndEventBanner: 'hit-and-event-banner',
  contactListBanner: 'contact-list-banner',
  contactTopBanner: 'contact-top-banner',
  ratingBanner: 'rating-banner',
  photoViewerBanner: 'photo-viewer-banner',
} as const

export const BannerPlaces = {
  contactListBanner: 'contact list banner',
  contactTopBanner: 'contact top banner',
  hitAndEventBanner: 'hit and event banner',
  searchListBanner: 'search list banner',
  topProfileBanner: 'top profile banner',
  photoViewerBanner: 'photo viewer banner',
  ratingBanner: 'rating banner',
  feedProfileBanner: 'feed profile banner',
} as const

/**
 * Баннера без HB
 */
export const BannerRtbId = {
  // импользуется в старом дизайне, удалить после удаления старого профиля
  ratingSwipe: 'R-A-601046-25',
  contactTopBanner: 'R-A-601046-3',
  profileFeedBanner: 'R-A-601046-30',
} as const
